
import { Navigation } from "@/components/Navigation";
import { CommunityTabs } from "@/components/community/CommunityTabs";
import { PrayerRequestsTab } from "@/components/community/PrayerRequestsTab";
import { CommunityHeader } from "@/components/community/CommunityHeader";
import { useEffect } from "react";

export default function GracefulPetitions() {
  // Ensure the page scrolls to top on load
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  
  return (
    <div className="min-h-screen bg-gradient-to-b from-[#1A1A25] to-[#0F111A] text-white pb-52">
      <div className="container py-8">
        <CommunityHeader />
        
        <div className="max-w-3xl mx-auto mt-6">
          <PrayerRequestsTab />
        </div>
      </div>
      <CommunityTabs />
      <div className="relative">
        <Navigation />
      </div>
    </div>
  );
}
